import { AppConfig } from '@superbet-group/web.lib.config';
import { instanceGuard } from '@superbet-group/web.lib.utilities';
import RestService from './_private/RestService';
import SingletonError from '../common/errors/SingletonError';
import Singleton from '../common/Singleton';

class SeoService {
    private static instance?: SeoService;

    public static getInstance(): SeoService {
        return instanceGuard(SeoService.instance);
    }

    public static createInstance(config: AppConfig) {
        if (!SeoService.instance) {
            SeoService.instance = new SeoService(config);
        }
        return SeoService.instance;
    }

    private restService: RestService;

    private constructor(private config: AppConfig) {
        if (SeoService.instance) {
            throw new SingletonError(this.constructor.name);
        }
        this.restService = new RestService();
    }

    public async getMetadata(url: string) {
        try {
            return await this.restService.getMetadata(url);
        } catch (e) {
            return null;
        }
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete SeoService.instance;
    }
}

export default SeoService as Singleton<SeoService>;
